uniform sampler2D u_tex;
uniform sampler2D u_noise;
uniform float u_time;
uniform float u_appear;
uniform float u_random;

varying vec3 vViewNormal;
varying vec3 vViewPosition;
varying vec2 vUv;


vec2 getMatcap(vec3 eye, vec3 normal) {
    vec3 reflected = reflect(eye, normal);
    float m = 2.8284271247461903 * sqrt(reflected.z + 1.0);
    return reflected.xy / m + 0.5;
}

void main() {
    vec3 eyeDir = normalize(vViewPosition); // Vue vers origine caméra
    vec2 matcapUv = getMatcap(eyeDir, normalize(vViewNormal));

    vec3 matcapColor = texture2D(u_tex, matcapUv).rgb;

    float noise = texture2D(u_noise, vec2(vUv.x*1.+ u_random, vUv.y*1.+ u_random)).r;

    noise = smoothstep(0.+u_appear, 0.1+u_appear, noise);
    noise = clamp(noise, 0., 1.);
    float lineSize = 0.15;
float test = smoothstep(0.+lineSize+u_appear, 0.+(lineSize*2.)+u_appear, noise) - smoothstep(0.+(lineSize*2.)+u_appear, 0.+(lineSize*3.)+u_appear, noise);
vec3 glow = vec3(1.0, 0.9, 0.6) * test * 100.0;
vec3 finalColor = matcapColor + glow;
// 
    gl_FragColor = vec4(finalColor, noise);
    // gl_FragColor = vec4(test, test, test, 1.);
}
